import React, {useEffect, useState} from 'react';
import _ from '../Trans'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import {Popover, PopoverBody, PopoverHeader} from "reactstrap";
const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

function getDateString(date) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();

    return `${day.toString().padStart(2, "0")}/${month.toString().padStart(2, "0")}/${year} ${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;
}

function convertTZ(date, tzString) {
    // for test purposes
    // tzString = 'Japan' // +9
    // tzString = 'Indian/Comoro' //	+3
    if(tzString=== "Etc/Unknown") {
        tzString = 'Europe/Madrid'
    }
    return new Date((typeof date === "string" ? new Date(date) : date)
        .toLocaleString("en-US", {timeZone: tzString}));
}


const useCountDown = (targetDate) => {
    let dateObject = null;
    try {
        dateObject = new Date(targetDate.replace(" ", "T") + "Z");
    }
    catch (e) {
        dateObject = new Date(targetDate);
    }
    const countDownDate= convertTZ(dateObject, timeZone);

    const [countDown, setCountDown] = useState(
        countDownDate - new Date().getTime()
    );

    useEffect(() => {
        const interval = setInterval(() => {
            setCountDown(countDownDate - new Date().getTime());
        }, 1000);

        return () => clearInterval(interval);
    }, [countDownDate]);

    return getReturnValues(countDown);
};

const getReturnValues = (countDown) => {
    const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
    const hours = Math.floor((countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((countDown % (1000 * 60)) / 1000);

    return [days, hours, minutes, seconds];
};

const ExpiredNotice = ({nextChangeWindowDateStart}) => {
    const [days, hours, minutes, seconds] = useCountDown(nextChangeWindowDateStart);
    if(days === 0 && hours === 0 && minutes === 0 && seconds === 0) {
        window.location.reload()
    }
    if(nextChangeWindowDateStart !== null) {
        nextChangeWindowDateStart = new Date(nextChangeWindowDateStart.replace(" ", "T") + "Z");
        nextChangeWindowDateStart = getDateString(convertTZ(nextChangeWindowDateStart, timeZone));
    }
    const [open, setOpen] = useState(false);
    const toggle = function(e) {
      setOpen(!open);
    }

    const nextChangeWindowTitle = _("Next change window")
    const noChangesAllowedMessage = _('No more changes, last matches ongoing.')
    let nextChangeWindowMessage = _('The next change window will start on')
    nextChangeWindowMessage += " " + nextChangeWindowDateStart

    let popover = (
        <Popover placement="bottom" isOpen={open} target="expired-notice-info" toggle={toggle} onClick={toggle}>
          <PopoverHeader className="font-weight-bold" style={{color: 'black'}}>{nextChangeWindowTitle}</PopoverHeader>
          <PopoverBody>
              {nextChangeWindowDateStart !== "" && nextChangeWindowDateStart !== null ? nextChangeWindowMessage : noChangesAllowedMessage}
          </PopoverBody>
        </Popover>
    )

  return (
    <div className="expired-notice">
      <FontAwesomeIcon icon={faInfoCircle} id="expired-notice-info" className="fa-info-circle"></FontAwesomeIcon> <span>{_('No changes allowed')}</span>
        {popover}
    </div>
  );
};

const DateTimeDisplay = ({ value, type, isDanger }) => {
    if(type === "Days") {
        return (<span style={{"paddingRight": "5px"}}>{value} {_('days')}</span>)
    }
  return (
    <span className={isDanger ? 'countdown danger' : 'countdown'}>{value}</span>
  );
};

const ShowCounter = ({ days, hours, minutes, seconds, color="#000000" }) => {
    let style = {'color': color}
    if(days === 0) {
        style['color'] = 'orange'
    }
    if(hours < 6 && days === 0) {
        style['color'] = 'red'
    }
  return (
    <div className="show-counter" style={style}>
        <DateTimeDisplay value={days} type={'Days'} isDanger={days <= 3} />
        <DateTimeDisplay value={hours} type={'Hours'} isDanger={false} />:
        <DateTimeDisplay value={minutes} type={'Minutes'} isDanger={false} />:
        <DateTimeDisplay value={seconds} type={'Seconds'} isDanger={false} />
    </div>
  );
};

const CountdownTimer = ({ targetDate, nextChangeWindowDateStart="", color }) => {
  const [days, hours, minutes, seconds] = useCountDown(targetDate);

  if(typeof days === "undefined" || Number.isNaN(days)) {
        return (
            <div className="right w-100 h-100"><span>{targetDate}</span></div>
        );
  }
  if (days + hours + minutes + seconds <= 0) {
    return <ExpiredNotice nextChangeWindowDateStart={nextChangeWindowDateStart}/>;
  } else {
    return (
      <ShowCounter
        days={days}
        hours={hours > 9 ? hours : "0"+hours}
        minutes={minutes > 9 ? minutes : "0"+minutes}
        seconds={seconds > 9 ? seconds : "0"+seconds}
        color={color}
      />
    );
  }
};

export default CountdownTimer;
